<template>
  <div>
    <b-button
      v-if="!hasValues"
      :disabled="disabled"
      :size="size"
      type="button"
      variant="primary"
      @click="addValue"
    >
      <i class="fa-solid fa-plus"></i> Add ICD-10
    </b-button>
    <template v-else v-for="(element, index) in values">
      <b-form-group>
        <b-input-group>
          <b-form-input
            readonly
            :size="size"
            :placeholder="`ICD-10 #${index + 1}`"
            :value="formatICD10Display(element)"
            @click="showICD10Modal(index)"
          />
          <template v-if="!disabled">
            <b-input-group-append>
              <b-button
                v-if="last === index"
                :size="size"
                :disabled="isMax"
                type="button"
                variant="success"
                @click="addValue"
              >
                <i class="fa-solid fa-plus"></i>
              </b-button>
              <b-button
                :size="size"
                type="button"
                variant="danger"
                @click="deleteValue(index)"
              >
                <i class="fa-solid fa-minus"></i>
              </b-button>
            </b-input-group-append>
          </template>
        </b-input-group>
      </b-form-group>
    </template>
  </div>
</template>
<script>
import Vue from 'vue'
import ICD10Modal from '../catalogue/ICD10Modal'
import { mapState, mapActions } from 'vuex'


export default {
  name: "multiple-icd10-field",
  props: {
    placeholder: {
      type: String,
      default: 'Set Placeholder'
    },
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxInputs: {
      type: Number,
      default: 5
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  data() {
    return {
      selectedIndex: null,
      values: []
    }
  },
  computed: {
    ...mapState('catalogue', {
      icd10: state => state.icd10_codes,
    }),
    isMin() {
      return this.values.length < 2
    },
    isMax() {
      return this.values.length === this.maxInputs
    },
    last() {
      return this.values.length - 1
    },
    hasValues() {
      return this.values.length > 0
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val.length) {
          this.values.length = 0
        } else {
          this.values = this.icd10.filter(obj => val.includes(obj.id))
        }
      }
    }
  },
  methods: {
    ...mapActions('catalogue', ['getCatalogueItem']),
    formatICD10Display(element) {
      if (!element || !element.code) return ''
      if (element.tag === 'subcode') {
        return `${element.parent} + ${element.code} - ${element.name}`
      }
      return `${element.code} - ${element.name}`
    },
    emitIds() {
      const ids = this.values.map(obj => obj.id)
      console.log('ICD10 emitIds called, values:', this.values, 'ids:', ids)
      this.$emit('input', ids)
    },
    deleteValue(index) {
      this.values.splice(index, 1)
      this.emitIds()
    },
    addValue() {
      this.values.push({})
      const lastIndex = this.values.length - 1
      this.showICD10Modal(lastIndex)
    },
    showICD10Modal(index) {
      const ComponentClass = Vue.extend(ICD10Modal)
      const instance = new ComponentClass({ parent: this })

      instance.$on("hidden", () => {
        instance.$destroy()
      })

      instance.$on("selected", (icd10) => {
        console.log('ICD10 selected event received:', icd10)
        this.values[index] = icd10
        console.log('ICD10 values after assignment:', this.values)
        this.emitIds()
      })

      instance.$mount()
    },
  },
  async mounted() {
    await this.getCatalogueItem('icd10_codes')
  }
}
</script>
